export const AMOUNT_PER_MONTH_SNG = 19.99;
export const AMOUNT_PER_MONTH_NO_SNG = 49.99;